<template>
  <div class="cart">
    <div class="content">
      <div class="panel-2-wrap" v-if="datas.length">
        <div class="panel-2">
          <div class="app-title">
            <span>为您推荐</span>
            <span @click="goGoods">更多<van-icon name="arrow"></van-icon></span>
          </div>
          <product-list :datas="datas.slice(0, 2)" @addCart="initPage" @removeCart="initPage"></product-list>
        </div>
      </div>
      <div class="panel-1-wrap" v-if="cartDatas.length">
        <div class="cart-top">
          <p>购物车<span>共{{cartDatas.length}}件商品</span></p>
          <p @click="emptyCart"><span>清空购物车</span></p>
        </div>
        <div class="empty" v-if="!cartDatas.length"></div>
        <div class="panel-1" v-else>
          <product-list :datas="cartDatas" @addCart="initPage" @removeCart="initPage" is-cart></product-list>
        </div>
      </div>
    </div>
    <div class="bottom" v-if="startSendTotalPrice < limitPrice">
      <div class="left-region">
        <p>
          <span>合计：<i>￥{{$store.state.cartTotalPrice}}</i></span>
          <span v-if="$store.state.allInfo && $store.state.allInfo.cart.allow_coupon_total_price">可用券金额：￥{{divideNumber($store.state.allInfo.cart.allow_coupon_total_price, 100)}}</span>
        </p>
        <p>还差<span>￥{{subtractNumber(limitPrice, startSendTotalPrice)}}</span>，满<span>{{limitPrice}}元</span>起送</p>
      </div>
      <van-button @click="goPage">去凑单</van-button>
    </div>
    <div class="bottom" v-else>
      <div class="left-region">
        <p>
          <span>合计：<i>￥{{$store.state.cartTotalPrice}}</i></span>
          <span v-if="$store.state.allInfo && $store.state.allInfo.cart.allow_coupon_total_price">可用券金额：￥{{divideNumber($store.state.allInfo.cart.allow_coupon_total_price, 100)}}</span>
        </p>
        <p>满{{limitPrice}}元起送</p>
      </div>
      <van-button @click="goOrder">下一步</van-button>
    </div>
    <van-dialog v-model="dialog.show" class="promotion-dialog" show-cancel-button close-on-click-overlay confirm-button-text="去结算" cancel-button-text="去凑单" @confirm="dialogConfirm" @cancel="dialogCancel">
      <div class="promotion-dialog-content">
        <button type="button" class="promotion-close" aria-label="关闭" @click="closePromotionDialog">
          <van-icon name="cross"></van-icon>
        </button>
        <div class="promotion-title">您当前订单</div>
        <div class="promotion-subtitle">优惠与满赠进度</div>

        <div class="coupon-progress-card" v-if="dialog.coupon">
          <div class="coupon-value">
            <van-icon name="coupon-o"></van-icon>
            <strong>￥{{formatPromotionPrice(dialog.coupon.discountPrice)}}</strong>
            <span>满{{formatPromotionPrice(dialog.coupon.thresholdPrice)}}可用</span>
          </div>
          <div class="coupon-divider"></div>
          <div class="coupon-detail">
            <span class="promotion-status">代金券</span>
            <strong>代金券优惠</strong>
            <p>还差 <em>￥{{formatPromotionPrice(dialog.coupon.remainingPrice)}}</em> 即可使用</p>
            <small>不可用券商品除外</small>
          </div>
        </div>

        <div class="gift-progress-card" v-if="dialog.gift">
          <div class="gift-progress-title">
            <strong><van-icon name="gift-o"></van-icon>满赠进度</strong>
            <span v-if="dialog.gift.unlocked" class="unlocked">已解锁</span>
            <span v-else>还差 <em>￥{{formatPromotionPrice(dialog.gift.remainingPrice)}}</em></span>
          </div>

          <div class="gift-tier-block current-tier" v-if="dialog.gift.currentGoods">
            <div class="gift-tier-heading">已获得赠品</div>
            <div class="gift-preview">
              <van-image fit="contain" :src="dialog.gift.currentGoods.image"></van-image>
              <div class="gift-preview-info">
                <strong>{{dialog.gift.currentGoods.title}}</strong>
                <small v-if="dialog.gift.currentGoods.spec">{{dialog.gift.currentGoods.spec}}</small>
              </div>
              <div class="gift-preview-count">
                <span>×{{dialog.gift.currentGoods.number}}</span>
                <em>免费</em>
              </div>
            </div>
          </div>

          <div class="gift-progress-wrap">
            <div class="gift-progress-track">
              <i :style="{width: dialog.gift.progress + '%'}"></i>
            </div>
            <div class="gift-progress-numbers">
              <span>计入满赠 ￥{{formatPromotionPrice(dialog.gift.currentPrice)}}</span>
              <span>满 ￥{{formatPromotionPrice(dialog.gift.targetPrice)}}</span>
            </div>
          </div>

          <div class="gift-tier-block next-tier" v-if="dialog.gift.nextGoods">
            <div class="gift-tier-heading">将获得赠品</div>
            <div class="gift-preview">
              <van-image fit="contain" :src="dialog.gift.nextGoods.image"></van-image>
              <div class="gift-preview-info">
                <strong>{{dialog.gift.nextGoods.title}}</strong>
                <small v-if="dialog.gift.nextGoods.spec">{{dialog.gift.nextGoods.spec}}</small>
              </div>
              <div class="gift-preview-count">
                <span>×{{dialog.gift.nextGoods.number}}</span>
                <em>免费</em>
              </div>
            </div>
          </div>

          <div class="gift-content" v-if="!dialog.gift.currentGoods && !dialog.gift.nextGoods">{{dialog.gift.content}}</div>
        </div>

        <p class="promotion-tip" v-if="dialog.gift && !dialog.gift.unlocked">
          再购 <em>￥{{formatPromotionPrice(dialog.gift.remainingPrice)}}</em>，{{dialog.gift.hasCurrentGift ? '可升级下一档赠品' : '即可免费获得以上赠品'}}
        </p>
        <p class="promotion-empty" v-if="!dialog.coupon && !dialog.gift">当前暂无待解锁优惠</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
  import CommonService from '@/io/common.js';
  import ProductList from '@/components/ProductList.vue';
  import { buildGiftProgressData } from '@/utils/promotion.js';

  export default {
    name: 'Cart',
    data() {
      return {
        dialog: {
          show: false,
          coupon: null,
          gift: null
        },
        limitPrice: 0,
        startSendTotalPrice: 0,
        cartDatas: [],
        merchantId: null,
        datas: []
      }
    },
    components: {
      ProductList
    },
    mounted () {
      this.initPage();
    },
    methods: {
      dialogConfirm() {
        this.$router.push({
          path: '/pay'
        });
      },
      dialogCancel() {
        this.$router.push({
          path: '/category'
        });
      },
      closePromotionDialog() {
        this.dialog.show = false;
      },
      formatPromotionPrice(value) {
        const amount = Number(value || 0);
        return amount.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
      },
      buildCouponProgress(couponInfo) {
        const next = couponInfo && couponInfo.next;
        if (!next) return null;

        const title = next.title || next.content || '';
        const thresholdMatch = title.match(/满\s*(\d+(?:\.\d+)?)/);
        const discountMatch = title.match(/减\s*(\d+(?:\.\d+)?)/);
        return {
          title,
          thresholdPrice: next.threshold_price !== undefined ? Number(next.threshold_price) : Number(thresholdMatch ? thresholdMatch[1] : 0),
          discountPrice: next.discount_price !== undefined ? Number(next.discount_price) : Number(discountMatch ? discountMatch[1] : 0),
          remainingPrice: next.remaining_price !== undefined
            ? Number(next.remaining_price)
            : Math.max(0, this.subtractNumber(next.min_price, this.$store.state.cartTotalPrice))
        };
      },
      buildGiftProgress(giftInfo, giftTotalPrice) {
        return buildGiftProgressData(giftInfo, giftTotalPrice, process.env.VUE_APP_IMAGE_URL);
      },
      initPage() {
        this.$toast.loading({
          message: '加载中...',
          duration: 0
        });
        CommonService.allInfo().then(res => {
          this.merchantId = res.merchant.id;
          this.initCartDatas(this.$store.state.allInfo);
          this.initDatas(res);
        }).catch(err => {}).finally(() => {
          this.$toast.clear();
        });
      },
      goGoods() {
        this.$router.push({
          path: `/goods?ids=${this.datas.map(val => val.id).join(',')}`
        });
      },
      goPage() {
        this.$router.push({
          path: '/category'
        });
      },
      emptyCart() {
        this.$toast.loading({
          message: '处理中...',
          duration: 0
        });
        CommonService.emptyCart(this.merchantId).then(res => {
          setTimeout(() => {
            // this.$store.commit('setCartTotalPrice', 0);
            this.updateCartInfo(this.merchantId, this.initPage);
          });
        }).catch(err => {}).finally(() => {
          this.$toast.clear();
        });
      },
      initCartDatas(res) {
        this.limitPrice = this.divideNumber(res.cart.allow_submit_order_min_price, 100);
        this.startSendTotalPrice = this.divideNumber(res.cart.start_send_total_price === undefined ? res.cart.total_price : res.cart.start_send_total_price, 100);
        const cartDatas = res.cart.cart.map(val => {
          let data;
          res.goods.forEach(m => {
            if (val.goods_id === m.id) {
              data = {
                ...m,
                number: val.num * 1,
                merchantId: this.merchantId,
                image: `${process.env.VUE_APP_IMAGE_URL}${m.image}`,
              }
            }
          });
          return data;
        }).filter(Boolean);
        const giftDatas = (res.cart.gift_goods || []).map(val => ({
          ...val,
          id: val.goods_id,
          merchantId: this.merchantId,
          image: process.env.VUE_APP_IMAGE_URL + val.image,
          is_gift: 1
        }));
        this.cartDatas = giftDatas.concat(cartDatas);
      },
      initDatas(res) {
        let goods = res.goods;
        let cartDatas = res.cart.cart;
        let datas = [];
        return CommonService.recommendGoods().then(res => {
          res.data.forEach(val => {
            goods.forEach(m => {
              if (val.goods_id === m.id) {
                datas.push({
                  ...m,
                  number: 0,
                  merchantId: this.merchantId,
                  image: `${process.env.VUE_APP_IMAGE_URL}${m.image}`,
                });
              }
            });
          });
          this.datas = datas.map(val => {
            let number = 0;
            cartDatas.forEach(m => {
              if (m.goods_id === val.id) {
                number = m.num * 1;
              }
            });
            val.number = number;
            return val;
          });
        }).catch(err => {});
      },
      goOrder() {
        this.$toast.loading({
          message: '处理中...',
          duration: 0
        });
        CommonService.allInfo(true, true).then(res => {
          this.merchantId = res.merchant.id;
          this.initCartDatas(res);
          this.initDatas(res);
          const couponInfo = res.cart.coupon_tip_info || {};
          const giftInfo = res.cart.gift_campaign_info || (res.cart.coupon_tip_info ? {} : res.cart.gift_info) || {};
          this.dialog.coupon = this.buildCouponProgress(couponInfo);
          this.dialog.gift = this.buildGiftProgress(giftInfo, res.cart.gift_total_price);
          this.dialog.show = true;
        }).catch(err => {

        }).finally(() => {
          this.$toast.clear();
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .cart {
    position: relative;
    .promotion-dialog-content {
      position: relative;
      max-height: 75vh;
      overflow-y: auto;
      padding: 38 * @r 42 * @r 28 * @r;
      color: #252525;
    }
    .promotion-close {
      position: absolute;
      z-index: 2;
      top: 18 * @r;
      right: 18 * @r;
      width: 52 * @r;
      height: 52 * @r;
      padding: 0;
      border: 0;
      border-radius: 50%;
      background: #f5f5f5;
      color: #777;
      font-size: 28 * @r;
      line-height: 52 * @r;
      text-align: center;
    }
    .promotion-title {
      text-align: center;
      font-size: 34 * @r;
      font-weight: bold;
      line-height: 1.2;
    }
    .promotion-subtitle {
      margin: 10 * @r 0 28 * @r;
      text-align: center;
      color: #999;
      font-size: 22 * @r;
    }
    .coupon-progress-card,
    .gift-progress-card {
      border: 1px solid #ffb69d;
      border-radius: 16 * @r;
      background: #fff8f5;
    }
    .coupon-progress-card {
      min-height: 150 * @r;
      padding: 20 * @r 22 * @r;
      display: flex;
      align-items: stretch;
    }
    .coupon-value {
      width: 170 * @r;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: @color-primary;
      .van-icon {
        font-size: 32 * @r;
      }
      strong {
        font-size: 46 * @r;
        line-height: 1.15;
      }
      span {
        color: #333;
        font-size: 21 * @r;
      }
    }
    .coupon-divider {
      width: 1px;
      margin: 0 24 * @r 0 8 * @r;
      border-left: 1px dashed #ff9d7b;
    }
    .coupon-detail {
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      strong {
        font-size: 27 * @r;
        margin-bottom: 9 * @r;
      }
      p {
        margin: 0;
        font-size: 23 * @r;
        em {
          color: @color-primary;
          font-size: 27 * @r;
        }
      }
      small {
        margin-top: 8 * @r;
        color: #999;
        font-size: 19 * @r;
      }
    }
    .promotion-status {
      position: absolute;
      top: 0;
      right: 0;
      padding: 4 * @r 12 * @r;
      border-radius: 20 * @r;
      background: @color-primary;
      color: #fff;
      font-size: 18 * @r;
    }
    .gift-progress-card {
      margin-top: 22 * @r;
      padding: 24 * @r;
    }
    .gift-progress-title,
    .gift-progress-numbers {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .gift-progress-title {
      font-size: 23 * @r;
      strong {
        display: flex;
        align-items: center;
        font-size: 27 * @r;
      }
      .van-icon {
        margin-right: 10 * @r;
        color: @color-primary;
        font-size: 34 * @r;
      }
      span {
        color: #888;
      }
      em,
      .unlocked {
        color: @color-primary;
      }
    }
    .gift-progress-track {
      height: 16 * @r;
      margin: 0 0 12 * @r;
      overflow: hidden;
      border-radius: 10 * @r;
      background: #ffe2d7;
      i {
        display: block;
        height: 100%;
        border-radius: inherit;
        background: linear-gradient(90deg, #ff5b22, @color-primary);
      }
    }
    .gift-progress-numbers {
      color: #888;
      font-size: 20 * @r;
    }
    .gift-progress-wrap,
    .gift-tier-block {
      margin-top: 18 * @r;
      padding-top: 18 * @r;
      border-top: 1px solid #ffe0d5;
    }
    .gift-tier-heading {
      color: @color-primary;
      font-size: 21 * @r;
      font-weight: bold;
    }
    .next-tier .gift-tier-heading {
      color: #666;
    }
    .gift-preview {
      display: flex;
      align-items: center;
      min-height: 90 * @r;
      margin-top: 8 * @r;
      .van-image {
        flex-shrink: 0;
        width: 110 * @r;
        height: 90 * @r;
        margin-right: 18 * @r;
        background: #fff;
        border-radius: 10 * @r;
      }
    }
    .gift-preview-info {
      min-width: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      strong {
        display: block;
        max-width: 100%;
        margin: 7 * @r 0;
        overflow: visible;
        line-height: 1.35;
        text-overflow: clip;
        white-space: normal;
        word-break: break-all;
        font-size: 24 * @r;
      }
      small {
        color: #888;
        font-size: 20 * @r;
      }
    }
    .gift-preview-count {
      flex-shrink: 0;
      margin-left: 12 * @r;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      font-size: 23 * @r;
      em {
        margin-top: 12 * @r;
        color: @color-primary;
      }
    }
    .gift-content {
      margin-top: 20 * @r;
      padding-top: 20 * @r;
      border-top: 1px solid #ffe0d5;
      font-size: 22 * @r;
      color: #666;
    }
    .promotion-tip,
    .promotion-empty {
      margin: 24 * @r 0 0;
      text-align: center;
      color: #777;
      font-size: 21 * @r;
      em {
        color: @color-primary;
      }
    }
    .promotion-empty {
      padding: 30 * @r 0;
    }
    .content {
      height: calc(100% - 110 * @r);
      overflow: auto;
      padding: 30 * @r 40 * @r;
      .cart-top {
        // padding: 0 40 * @r;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 120 * @r;
        & > p {
          font-size: 34 * @r;
          font-weight: bold;
          // margin-bottom: 26 * @r;
          span {
            font-size: 22 * @r;
            color: #AFB2B9;
            margin-left: 18 * @r;
            font-weight: initial;
          }
        }
      }
      .panel-1-wrap {
        // padding: 0 40 * @r 28 * @r 40 * @r;
        // max-height: 60%;
        // overflow: auto;
      }
      .panel-2-wrap {
        // padding: 28 * @r 40 * @r;
        // max-height: 40%;
        // overflow: auto;
      }
      .empty {
        .setImg('/cart-empty.png');
        margin: 84 * @r auto 126 * @r auto;
      }
    }
    .bottom {
      height: 110 * @r;
      position: absolute;
      bottom: 0;
      border-top: 1px solid #D5D5D5;
      display: flex;
      justify-content: space-between;
      width: 100%;
      .left-region {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 30 * @r;
        flex: 1;
        & > p {
          &:nth-of-type(1) {
            display: flex;
            align-items: center;
            line-height: 100%;
            span {
              &:nth-of-type(1) {
                font-size: 28 * @r;
              }
              &:nth-of-type(2) {
                margin-left: 10 * @r;
                font-size: 24 * @r;
              }
              i {
                color: @color-primary;
              }
            }
          }
          &:nth-of-type(2) {
            font-size: 22 * @r;
            color: #AFB2B9;
            span {
              color: @color-danger;
            }
          }
        }
      }
      .van-button {
        height: 100%;
        border: none;
        padding: 0;
        width: 206 * @r;
        background-color: @color-primary;
        color: #FFFFFF;
        border-radius: 0;
      }
    }
  }
</style>
